exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-logo[data-v-6b5aacf1]{margin-right:.1rem}", ""]);

// exports
